// 現在のページをヘッダーに伝える
export const setPage = (page: string) => {
  return {
    type: page,
  };
};

export type headerAction = ReturnType<typeof setPage>;
